import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import "./ProductShowcase.css";

import paperbags01 from "../assets/img/Products/PaperBags/SOS-Paper-Bags.jpg"
import paperbags02 from "../assets/img/Products/PaperBags/E-Commerce-Paper-Bags.jpg"
import paperbags03 from "../assets/img/Products/PaperBags/Grocery-Bags.jpg"
import paperbags04 from "../assets/img/Products/PaperBags/Printing-and-Customisation.jpg"
import paperbags05 from "../assets/img/Products/PaperBags/Premium-gifting-paper-Bags.png"

import foodpackaging01 from "../assets/img/Products/FoodPackaging/FSC-certified-Paper-bags-for-food-delivery.jpg"
import foodpackaging02 from "../assets/img/Products/FoodPackaging/F&B.jpg"
import foodpackaging03 from "../assets/img/Products/FoodPackaging/Cup-holder-trays.jpg"
import foodpackaging04 from "../assets/img/Products/FoodPackaging/Meal-and-Salad-Boxes.jpg"
import foodpackaging05 from "../assets/img/Products/FoodPackaging/Takeaway-Containers-and-wraps-for-Burgers-and-Rolls.jpg"


import sustainable01 from "../assets/img/Products/Sustainable/Kraft-Paper.jpg"
// import sustainable02 from "../assets/img/Products/Sustainable/Recycled-Paper.jpg"
import sustainable03 from "../assets/img/Products/Sustainable/Multi-use-Non-Woven-with-lamination-bags.jpg"
// import sustainable04 from "../assets/img/Products/Sustainable/Sugarcane-Bagasse-Products.jpg"
import sustainable05 from "../assets/img/Products/Sustainable/Natural-materials-Packaging.jpg"


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);


const categories = [
  {
    id: "paper-bags",
    label: "Paper Bags",
    intro: "Sustainable paper bags for every retail requirement.",
    products: [
       {
        eyebrow: "Kraft",
        title: "Square bottom Kraft Paper Bags with Twisted Handle",
        description:
          "High-strength flat handles built for comfort. Crafted for apparel, gifting, and retail environments.",
        tags: ["Retail", "Gift", "Apparel"],
        image: paperbags01,
      },
      {
        eyebrow: "SOS",
        title: "Shopping and Grocery SOS Bags",
        description:
          "Square-bottom construction that stands on its own. Made for high-volume food, pharmacy, and grocery use.",
        tags: ["Food Safe", "High Volume", "Custom Print"],
        image: paperbags02,
      },
     
      {
        eyebrow: "Pharmacy",
        title: "Retail & Apparel Bags",
        description:
          "High-quality paper bags built for the demands of the fashion and retail industry. Whether you need reliable flat-handle bags for everyday retail or luxury twisted-handle bags for boutiques, we manufacture packaging that protects your products and beautifully communicates your brand.",
        tags: ["Retail", "Apparel", "Fashion", "Custom Print", "Boutique"],
        image: paperbags03,
      },
      {
        eyebrow: "Printed",
        title: "Custom Printed coloured Bags",
        description:
          "Imported twisted handles with superior grip. An elevated finish for boutiques and high-end brands.",
        tags: ["Luxury", "Boutique", "Events"],
        image: paperbags04,
      },
       {
        eyebrow: "Gifting",
        title: "Premium gifting paper Bags",
        description:
          "Imported twisted handles with superior grip. An elevated finish for boutiques and high-end brands.",
        tags: ["Luxury", "Boutique", "Events"],
        image: paperbags05,
      },
    ],
  },

  {
    id: "food-packaging",
    label: "Food Packaging",
    intro: "Food-safe packaging designed for modern food businesses.",
    products: [
      {
        eyebrow: "FSC certified bag",
        title: "FSC certified Paper bags for food delivery",
        description:
          "Responsible paper bags designed for food delivery applications with sustainability at their core.",
        tags: ["FSC", "Food Safe", "Delivery"],
        image: foodpackaging01,
      },
      {
        eyebrow: "F&B Bags",
        title: "F&B Bags",
        description:
          "Food-safe, grease-resistant packaging built for the demands of the F&B industry. Engineered for restaurants, cafes, and Quick Service Restaurants (QSRs), these bags securely handle hot, cold, and heavy deliveries without compromising your brand’s presentation.",
        tags: ["Food & Beverage", "Takeaway", "Grease Resistant", "Food-Safe"],
        image: foodpackaging02,
      },
      {
        eyebrow: "Cup holder",
        title: "Cup holder trays",
        description:
          "Practical takeaway packaging for meals, salads, burgers, rolls, and modern food-service operations.",
        tags: ["Takeaway", "Food Safe", "Custom"],
        image: foodpackaging03,
      },
        {
        eyebrow: "Food Boxes",
        title: "Meal and Salad  Boxes",
        description:
          "Practical takeaway packaging for meals, salads, burgers, rolls, and modern food-service operations.",
        tags: ["Takeaway", "Food Safe", "Custom"],
        image: foodpackaging04,
      },
       {
        eyebrow: "Takeaway Containers",
        title: "Takeaway Containers and wraps for Burgers and Rolls",
        description:
          "Practical takeaway packaging for meals, salads, burgers, rolls, and modern food-service operations.",
        tags: ["Takeaway", "Food Safe", "Custom"],
        image: foodpackaging05,
      },
    ],
  },

  {
    id: "sustainable-materials",
    label: "Sustainable Materials",
    intro:
      "Responsible materials for businesses moving toward a circular future.",
    products: [
      {
        eyebrow: "NATURAL & VERSATILE",
        title: "Kraft Paper",
        description:
          "Reliable kraft paper solutions suitable for a wide range of packaging applications.",
        tags: ["Kraft", "Recyclable", "Natural"],
        image: sustainable01,
      },
      // {
      //   eyebrow: "GIVING MATERIALS A SECOND LIFE",
      //   title: "Recycled Paper",
      //   description:
      //     "Recycled paper options designed to reduce dependence on virgin materials.",
      //   tags: ["Recycled", "Eco", "Circular"],
      //   image: sustainable02,
      // },
       {
        eyebrow: "Multi use bags",
        title: "Multi use Non Woven Laminated bags",
        description:
          "Heavy-duty, reusable carriers designed for extended lifespans. Featuring a water-resistant laminated finish and optional insulated interiors, these bags provide superior temperature control and structural strength for groceries, food delivery, and demanding daily use.",
        tags: ["Non-woven", "Insulated", "Laminated", "Reusable"],
        image: sustainable03,
      },
      // {
      //   eyebrow: "PLANT-BASED ALTERNATIVE",
      //   title: "Sugarcane Bagasse Products",
      //   description:
      //     "Plant-based packaging alternatives made from sugarcane bagasse for food and industrial applications.",
      //   tags: ["Bagasse", "Plant Based", "Compostable"],
      //   image: sustainable04,
      // },
          {
        eyebrow: "Natural",
        title: "Natural and Plant based alternative",
        description:
          "Plant-based packaging alternatives made from sugarcane bagasse for food and industrial applications.",
        tags: ["Bagasse", "Plant Based", "Compostable"],
        image: sustainable05,
      },
    ],
  },
];

function ProductShowcase() {
  const sectionRef = useRef(null);
  const sectionRefs = useRef({});
  const animationRefs = useRef({});
const cardsRef = useRef(null);
  const [activeTab, setActiveTab] = useState(categories[0]?.id);

  const activeIndex = categories.findIndex(
    (category) => category.id === activeTab
  );

  useEffect(() => {
    const ctx = gsap.context(() => {
      const sections = Object.values(sectionRefs.current);

      if (!sections.length) return;

      const triggers = sections.map((section) => {
        return ScrollTrigger.create({
          trigger: section,

          start: "top center",
          end: "bottom center",

          onEnter: () => {
            setActiveTab(section.id);
          },

          onEnterBack: () => {
            setActiveTab(section.id);
          },
        });
      });

      return () => {
        triggers.forEach((trigger) => trigger.kill());
      };
    }, sectionRef);

    return () => ctx.revert();
  }, []);


  useEffect(() => {
  const cards = cardsRef.current?.querySelectorAll("#ProductCategory");

  if (!cards?.length) return;

  const ctx = gsap.context(() => {
    gsap.fromTo(
      cards,
      {
        opacity: 0,
        y: 50,
        scale: 0.96,
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.7,
        stagger: 0.1,
        ease: "power3.out",
        clearProps: "transform",
      }
    );
  }, cardsRef);

  return () => ctx.revert();
}, [activeIndex]);

  /*
   * Animate each product section when it enters
   */
  useEffect(() => {
    const section = sectionRefs.current[activeTab];

    if (!section) return;

    const cards = section.querySelectorAll(".product-card");

    if (!cards.length) return;

    animationRefs.current[activeTab]?.kill();

    gsap.set(cards, {
      opacity: 0,
      y: 40,
      scale: 0.97,
    });

    animationRefs.current[activeTab] = gsap.to(cards, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.6,
      stagger: 0.08,
      ease: "power3.out",
      clearProps: "transform",
    });

    return () => {
      animationRefs.current[activeTab]?.kill();
    };
  }, [activeTab]);

  /*
   * TAB CLICK
   */
  const handleTabClick = (categoryId) => {
    const target = sectionRefs.current[categoryId];

    if (!target) return;

    setActiveTab(categoryId);

    gsap.to(window, {
      duration: 0.8,
      scrollTo: {
        y: target,
        offsetY: 80,
      },
      ease: "power3.inOut",
    });
  };

  return (
    <section
      ref={sectionRef}
      className="product-showcase"
      id="products"
    >
      <div class="background_split-circle is-home_join"></div>
      <Container
        className="py-lg-5 px-lg-5"
        fluid
      >
        {/* HEADER */}

        <div className="showcase-header">
          <div className="showcase-header-grid">
            <h2 className="showcase-heading">
              <span className="heading-mask">
                <span className="showcase-heading-line">
                  Built for Every Brand,
                </span>
              </span>

              <span className="heading-mask">
                <span className="showcase-heading-line">
                  Every Industry, Every Scale
                </span>
              </span>
            </h2>

            <p className="showcase-intro">
              From luxury boutiques to national grocery
              chains, every bag leaves our facility
              quality-checked.
            </p>
          </div>
        </div>

        {/* TABS */}

        <div className="category-navigation">
          {categories.map((category) => (
            <button
              key={category.id}
              type="button"
              className={
                activeTab === category.id
                  ? "category-navigation-tab active"
                  : "category-navigation-tab"
              }
              onClick={() =>
                handleTabClick(category.id)
              }
            >
              <span className="category-tab-number">
                {/* {String(
                  categories.indexOf(category) + 1
                ).padStart(2, "0")} */}
              </span>

              <span>{category.label}</span>

              <span className="category-tab-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24" height="24">
  <path d="M14 50L50 14" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M27 14H50V37" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              </span>
            </button>
          ))}
        </div>

        {/* ALL PRODUCT CATEGORY SECTIONS */}

        <div className="product-category-sections px-lg-5 py-lg-5" ref={cardsRef} id="ProductCategory">
          {categories.map((category, categoryIndex) => (
            <section
              key={category.id}
              id={category.id}
              ref={(element) => {
                if (element) {
                  sectionRefs.current[category.id] =
                    element;
                }
              }}
              className="product-category-section px-lg-5 py-lg-5"
            >
              {/* CATEGORY HEADER */}

              <div className="active-category">
                <div className="active-category-info">
                  {/* <span className="category-index">
                    {String(categoryIndex + 1).padStart(
                      2,
                      "0"
                    )}
                  </span> */}

                  <h2>{category.label}</h2>

                  <p>{category.intro}</p>
                </div>

                {/* PROGRESS */}

                <div className="category-progress">
                  {categories.map((item) => (
                    <span
                      key={item.id}
                      className={
                        activeTab === item.id
                          ? "active"
                          : ""
                      }
                    />
                  ))}
                </div>
              </div>

              {/* PRODUCTS */}

              <div className="product-cards">
                {category.products.map((product) => (
                  <article
                    className="product-card"
                    key={product.title}
                  >
                    <div className="product-image">
                      <img
                        src={product.image}
                        alt={product.title}
                        loading="lazy"
                        onError={(event) => {
                          event.currentTarget.style.display =
                            "none";

                          event.currentTarget.parentElement.classList.add(
                            "image-missing"
                          );
                        }}
                      />

                      <div className="image-placeholder">
                        <span>MEF</span>

                        <small>
                          {product.title}
                        </small>
                      </div>
                    </div>

                    <div className="product-card-content">
                      {/* <span className="product-eyebrow">
                        {product.eyebrow}
                      </span> */}

                      <h3>{product.title}</h3>

                      <p>
                        {product.description}
                      </p>

                      <div className="product-tags">
                        {product.tags.map((tag) => (
                          <span key={tag}>
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </section>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default ProductShowcase;